import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useApp } from "./context";
import { t } from "./i18n";

export default function Header() {
  const { lang, setLang } = useApp();
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");

  const links = [
    { to: "/", label: t("nav.home", lang), end: true, tid: "nav-home" },
    { to: "/apartments", label: t("nav.apartments", lang), tid: "nav-apartments" },
    { to: "/services", label: t("nav.services", lang), tid: "nav-services" },
    { to: "/about", label: t("nav.about", lang), tid: "nav-about" },
    { to: "/faq", label: t("nav.faq", lang), tid: "nav-faq" },
    { to: "/contact", label: t("nav.contact", lang), tid: "nav-contact" },
  ];

  if (isAdmin) return null;

  return (
    <header className="nav-glass" data-testid="site-header">
      <div className="container-x flex items-center justify-between py-5">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-logo">
          <span className="font-display text-2xl md:text-3xl tracking-tight" style={{letterSpacing:'0.02em'}}>STILET</span>
          <span className="overline hidden md:inline" style={{color:'var(--text-muted)'}}>Kotor</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={l.tid}
              className={({isActive}) => `nav-link ${isActive ? 'active' : ''}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="lang-toggle"
            onClick={() => setLang(lang === "en" ? "sr" : "en")}
            className="overline"
            style={{ background:'transparent', border:'1px solid var(--border)', padding:'8px 12px', cursor:'pointer' }}>
            {lang === "en" ? "EN · SR" : "SR · EN"}
          </button>
          <Link to="/apartments" className="hidden md:inline-flex btn-primary" data-testid="header-book-cta">
            {t("hero.cta_book", lang)}
          </Link>
        </div>
      </div>
    </header>
  );
}
